const backendBase = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/?$/, '/');

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

const tenantId = () => localStorage.getItem('tenantId') || localStorage.getItem('tenant_id');

/**
 * Load persisted chat run trace (master row + chat_execution_log steps).
 * @param {string} requestId
 * @returns {Promise<Object>}
 */
export const fetchChatExecutionTrace = async (requestId) => {
  const tid = tenantId();
  if (!requestId || !tid) {
    throw new Error('Missing request or tenant context');
  }
  const url = `${backendBase}synctrack/ai-execution/request/${encodeURIComponent(requestId)}?tenant_id=${encodeURIComponent(tid)}&include_chat_steps=true&include_mcp_logs=true`;
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.message || `Failed to load run trace (${res.status})`);
  }
  return res.json();
};

/**
 * Load agent_execution_log rows for a task queue run.
 * @param {string} taskId
 * @returns {Promise<Array>}
 */
export const fetchTaskExecutionLogs = async (taskId) => {
  if (!taskId) {
    throw new Error('Missing task id');
  }
  const url = `${backendBase}synctrack/agent/execution-logs/task/${encodeURIComponent(taskId)}`;
  const res = await fetch(url, { headers: authHeaders() });
  if (!res.ok) {
    if (res.status === 404) {
      return [];
    }
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || err.message || `Failed to load execution log (${res.status})`);
  }
  return res.json();
};
